import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "影视分类", to: "/category" },
  { label: "影评专题", to: "/special" },
  { label: "关于", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative py-2 text-sm transition-colors duration-200 whitespace-nowrap ${
      isActive
        ? "text-primary-600 font-medium"
        : "text-foreground-700 hover:text-primary-500"
    }`;

  return (
    <header className="sticky top-0 z-50 bg-background-50/90 backdrop-blur border-b border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-md bg-primary-600 flex items-center justify-center">
              <i className="ri-clapperboard-line text-background-50 text-lg" />
            </span>
            <span className="font-heading text-lg font-bold text-foreground-950 whitespace-nowrap">
              出轨的妻子
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-7">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form
              onSubmit={submitSearch}
              className="hidden md:flex items-center gap-1.5 rounded-full border border-background-300 bg-background-100 px-3 py-1.5"
            >
              <i className="ri-search-line text-foreground-500 text-sm" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视或影评"
                className="w-32 xl:w-44 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none"
              />
            </form>
            <Link
              to="/search"
              aria-label="搜索"
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-lg" />
            </Link>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50">
          <nav className="mx-auto max-w-7xl px-4 py-3 flex flex-col">
            <form
              onSubmit={submitSearch}
              className="flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-2 mb-2"
            >
              <i className="ri-search-line text-foreground-500" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视或影评"
                className="flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none"
              />
              <button type="submit" className="text-sm text-primary-600 font-medium whitespace-nowrap cursor-pointer">
                搜索
              </button>
            </form>
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `py-2.5 text-sm border-b border-background-100 last:border-0 ${
                    isActive ? "text-primary-600 font-medium" : "text-foreground-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}